import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { getMasterReferralSource } from "../../../actions/Master";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import { TabData } from "../../../models/TabSessionStorage";
import ReferralSource from "../components/ReferralSource";
import { getListResult } from "../../../utils";

const mapStateToProps = ({
    masterReferralSourceState,
    tabSessionStorageState,
    memberInfoDataState,
}: ApplicationState) => ({
    masterReferralSourceState: getListResult(masterReferralSourceState.response),
    TabSessionStorage: tabSessionStorageState,
    memberInfoDataState: memberInfoDataState.response
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
        resetStates: (actionType: string, field?: string) => {
            dispatch(resetStates(actionType, field));
        },
        saveTabSessionStorage: (SessionData: TabData) => {
            dispatch(saveTabSessionStorageResp(SessionData));
        },
        getMasterReferralSource: () => {
            dispatch(getMasterReferralSource());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralSource);